var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLcaUlogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x3C_Layer_x3E_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 163.2",
    style: {
      enableBackground: "new 0 0 142 163.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126,2.3c4.5,0,8.6,0,13,0c0,0.9,0.1,1.7,0.1,2.6c0,38.3,0,76.6,0,114.9c0,2.9-0.2,5.9-0.6,8.8 c-0.8,5.2-3.3,8.1-8.2,8.4c-5.1,0.4-10.4,0.5-15.5,0c-5.2-0.5-7.8-3.6-8.4-9.1c-0.3-2.4-0.5-4.9-0.5-7.4c0-38.6,0-77.3,0-115.9 c0-0.7,0-1.4,0-2.3c4.7,0,9.2,0,14,0c0,1,0,2,0,3c0,37.3,0,74.7,0,112c0,1.1,0,2.3,0.1,3.4c0,2.2,1.2,3,3.1,3s2.8-1,2.8-3 c0-1.2,0-2.5,0-3.7c0-37.1,0-74.2,0-111.3C126,4.7,126,3.6,126,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,121c0,2.5-0.2,4.9-0.5,7.3c-0.6,5.2-3.3,8.4-8.2,8.7c-5.1,0.4-10.4,0.5-15.5,0c-5.2-0.5-7.7-3.6-8.4-9.2 c-0.2-1.8-0.4-3.6-0.4-5.4c0-35.4,0-70.9,0-106.3c0-1.8,0.2-3.6,0.4-5.4c0.7-5.9,3.7-9,9.8-9.4c4.7-0.3,9.4-0.1,14.1,0.3 c4.6,0.4,7.2,3.3,8,8.1c0.3,1.8,0.5,3.6,0.5,5.4c0,13.1,0,26.2,0,39.6c-4.4,0-8.5,0-12.9,0c0-1.1,0-2.1,0-3c0-11,0-22,0-33 c0-1.6,0-3.2-2-3.7c-2.5-0.6-3.9,0.4-4.1,3.1c-0.1,0.8,0,1.6,0,2.5c0,32.4,0,64.8,0,97.2c0,0.9,0,1.8,0.1,2.7 c0.1,2.1,1.1,3.1,3.1,3.1c2.1,0,2.9-1.1,2.9-3.2c0-13.1,0-20.4,0-33.6c0-1,0,0.8,0-0.3c4.4,0,8.6,0,12.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M102.9,136.6c-4.8,0-9.3,0-14,0c-0.4-6-0.8-11.9-1.1-18c-2.6,0-5.2,0-7.9,0c-0.3,5.9-0.6,11.8-1,17.9 c-4.1,0-8.2,0-12.5,0c2.9-44.7,5.8-89.4,8.7-134.1c6.4,0,12.7,0,19.1,0C97.1,47,100,91.7,102.9,136.6z M84,22.7 C83,47,81.9,80,81,104.3c2.2,0,4.1,0,6.1,0C86,79.9,85,46.9,84,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,122.8c3.7,0,6.9,0,10.3,0c0,4.6,0,9.1,0,13.7c-8,0-15.9,0-24.1,0c0-44.7,0-89.4,0-134.2 c4.6,0,9,0,13.8,0C17.3,42.4,17.3,82.4,17.3,122.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 147.4,
    className: "st0",
    width: 135.6,
    height: 14
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLcaUlogoWhite);
export default __webpack_public_path__ + "static/media/Logo_LCAU logo_white.e758b6d00faa6a41294dcafcc80dc820.svg";
export { ForwardRef as ReactComponent };